module.exports = __webpack_public_path__ + "img/Savings.d0cbc4c3.svg";